import { ProtocolContentData } from "../../protocol";
export default class TakeOverWatch extends ProtocolContentData {
    authorRole;
    oow;
    takeOverWatchFrom;
    lookout;
    helmsman;
    freeText;
    constructor(takeOverWatchFrom, authorRole, oow, lookout, helmsman, freeText) {
        super();
        this.takeOverWatchFrom = takeOverWatchFrom;
        this.authorRole = authorRole;
        this.oow = oow;
        this.lookout = lookout;
        this.helmsman = helmsman;
        this.freeText = freeText;
    }
}
//# sourceMappingURL=TakeOverWatch.js.map